/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveEmergencyEmailRequest
 */
export interface RemoveEmergencyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveEmergencyEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the RemoveEmergencyEmailRequest interface.
 */
export function instanceOfRemoveEmergencyEmailRequest(value: object): value is RemoveEmergencyEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RemoveEmergencyEmailRequestFromJSON(json: any): RemoveEmergencyEmailRequest {
    return RemoveEmergencyEmailRequestFromJSONTyped(json, false);
}

export function RemoveEmergencyEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveEmergencyEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function RemoveEmergencyEmailRequestToJSON(json: any): RemoveEmergencyEmailRequest {
    return RemoveEmergencyEmailRequestToJSONTyped(json, false);
}

export function RemoveEmergencyEmailRequestToJSONTyped(value?: RemoveEmergencyEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

